import { NON_WHITESPACE } from '../../../utils';
var PATTERN = /[\d~`!@#$%^&*()_=+[\];"\\/<>?:{}|\\]/;

var validateName = value => {
  var isPresent = Boolean(value.length) && NON_WHITESPACE.test(value);
  var result = {
    patternMismatch: PATTERN.test(value),
    tooLong: isPresent && value.length > 100,
    valueMissing: !isPresent
  };
  result.errors = Object.keys(result).filter(key => result[key]);
  result.isValid = !result.errors.length;
  return result;
};

export { validateName };